/**
 * Appointment type constants for Transfer/No-Transfer outcomes
 * Based on comprehensive spreadsheet list
 * Actual values are used as keys in metadata, Display values are shown in UI
 */

// Mapping of Actual value (key) to Display value (UI label)
export const APPOINTMENT_TYPE_DISPLAY_MAP: Record<string, string> = {
  'MEDICARE ANNUAL WELLNESS': 'Medicare Annual Wellness',
  'ANNUAL WELLNESS': 'Adult Annual Wellness',
  'FOLLOW UP': 'Follow-Up',
  'POST-OP FOLLOW UP': 'Post-Op Follow-Up',
  'LAB VISITS': 'Lab Visits',
  "FOLLOW-UP WITH X-RAY": "Follow-Up with X-Ray",
  'NURSE VISITS': 'Nurse Visits',
  'TELEHEALTH MAWV': 'Telehealth MAWV',
  'TELEHEALTH FOLLOW-UP': 'Telehealth Follow-Up',
  'TELEHEALTH NURSE': 'Telehealth Nurse',
  'TELEHEALTH ESTABLISHED': 'Telehealth Established',
  'POST-OP': 'Post-Op',
  'EXTENDED ESTABLISHED (ALERTED)': 'Extended Established (Alerted)',
  PHYSICAL: 'Physical',
  'WELL CHILD': 'Well Child',
  'NEW PATIENT': 'New Patient',
  'TELEHEALTH NEW PATIENT': 'Telehealth New Patient',
  'BARIATRIC FOLLOW-UP': 'Bariatric Follow-Up',
  "BARIATRIC PREOP": "Bariatric Preop",
  'COVID-19': 'Covid-19 Established',
  'NEW OB': 'New OB',
  'RETURN OB': 'Return OB',
  PROCEDURE: 'Procedure',
  SURGERY: 'Surgery',
  'WALK-IN': 'Walk-In',
  'NURSE TCM CALL': 'Nurse TCM Call',
  'COVID-19 NEW': 'Covid-19 New',
  'BARIATRIC NEW': 'Bariatric New',
  'TELEHEALTH HOSPITAL FOLLOW-UP': 'Telehealth Hospital Follow-Up',
  'HOSPITAL FOLLOW-UP': 'Hospital Follow-Up',
  'NEW TRANSFER PROVIDER': 'New Transfer Provider',
  'NEW TRANSFER PROVIDER TELEHEALTH':
    'Telehealth New Transfer Provider',
  'TELEHEALTH SICK/ACUTE': 'Telehealth Sick/Acute',
  'SICK/ACUTE': 'Sick/Acute',
  'TELEHEALTH SAME DAY': 'Telehealth Same Day',
  'SAME DAY': 'Same Day',
  ROUTINE: 'Routine',
  'TELEHEALTH EDUCATION VISITS': 'Telehealth Education Visits',
  'TELEHEALTH OB VISITS': 'Telehealth Return OB',
  'EDUCATION VISITS': 'Education Visits',
  'INJECTIONS VISITS': 'Injections Visits',
  BIOPSY: 'Biopsy',
  'SUTURE STAPLE REMOVAL': 'Suture Staple Removal',
  'DIAGNOSTIC TEST': 'Diagnostic Test',
  BOTOX: 'Botox',
  'SPECIALITY FOLLOW UP': 'Speciality Follow-Up',
  'EXTENDED NEURO NEW': 'Extended Neuro New',
  CYSTO: 'Cysto',
  VASECTOMY: 'Vasectomy',
  POSTPARTUM: 'Postpartum',
  PUMP: 'Pump',
  PREOP: 'Preop',
  'POST PROCEDURE': 'Post Procedure',
  'NEW CANCER': 'New Cancer',
  DEVICE_CHECK: 'Device Check',
  'RETURN VISIT': 'Return Visit',
  'TELEHEALTH ANY': 'Telehealth Any',
  ESTABLISHED: 'Established',
  'COLOR ME HEALTHY': 'Color Me Healthy',
  'OCCUPATIONAL MEDICINE': 'Occupational Medicine',
  'OFFICE VISIT': 'Office Visit',
  GYNECOLOGICAL: 'Gynecological',
  'ESTABLISHED OB': 'Established OB',

};

// All actual values (keys) from the mapping
export const ALL_APPOINTMENT_TYPES = Object.keys(
  APPOINTMENT_TYPE_DISPLAY_MAP
) as readonly string[];

export type AppointmentType = string; // Allow any string value

/**
 * Get display name for an appointment type (actual value)
 * Falls back to the actual value if no mapping exists (for backward compatibility)
 */
export function getAppointmentTypeDisplayName(actualValue: string): string {
  return APPOINTMENT_TYPE_DISPLAY_MAP[actualValue] || actualValue;
}

/**
 * Get appointment type options for dropdown
 * Returns options with actual value as key and display value as label
 */
export function getAppointmentTypeOptions(): Array<{
  label: string;
  value: string;
}> {
  return Object.entries(APPOINTMENT_TYPE_DISPLAY_MAP)
    .map(([actualValue, displayValue]) => ({
      label: displayValue,
      value: actualValue,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)); // Sort by display name alphabetically
}

/**
 * Check if an appointment type is in the list
 * (Deprecated - kept for backward compatibility)
 */
export function isDefaultAppointmentType(
  appointmentType: string
): boolean {
  return appointmentType in APPOINTMENT_TYPE_DISPLAY_MAP;
}

